import React from "react";
import ReactDOM from "react-dom";
import "./index.css";
import App from "./App";
import reportWebVitals from "./reportWebVitals";
import "./i18nextConf";
import * as serviceWorkerRegistration from "./serviceWorkerRegistration";
import { Provider } from "react-redux";
import { persistor, store } from "./store/Store";
import { PersistGate } from "redux-persist/integration/react";
import * as Sentry from "@sentry/react";
import { BrowserTracing } from "@sentry/tracing";
import { ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";

// import { unregister as unregisterServiceWorker } from './serviceWorkerRegistration'

Sentry.init({
  dsn: process.env.REACT_APP_SENTRY_DSN,
  tracesSampleRate: 1.0,
  release: process.env.REACT_APP_TAG_VERSION,
  replaysOnErrorSampleRate: 1.0,
  replaysSessionSampleRate: 0.1,
  integrations: [new Sentry.Replay(), new BrowserTracing() as any],
});

ReactDOM.render(
  <React.StrictMode>
    <Provider store={store}>
      <PersistGate loading={null} persistor={persistor}>
        <App />
      </PersistGate>
    </Provider>
    <ToastContainer
      containerId="toastify-container"
      draggable={false}
      position="bottom-center"
      rtl
    />
  </React.StrictMode>,
  document.getElementById("root")
);
// const updateHandler = (registration: ServiceWorkerRegistration) => {
//   // if (window.confirm("Update available. Do you want to reload?")){
//   //   window.location.reload();
//   // }
//   console.log('sw is updated!!!')

// };
// const successHandler = (registration: ServiceWorkerRegistration) => {
//   console.log('sw is already updated!!!')
// };
// serviceWorkerRegistration.register({
// onUpdate: updateHandler,
// onSuccess: successHandler,
// });

// if ("serviceWorker" in navigator) {
//   navigator.serviceWorker.ready.then((registration) => {
//     registration.unregister();
//
//     if (caches) {
//       // Service worker cache should be cleared with caches.delete()
//       caches.keys().then(async (names) => {
//         await Promise.all(names.map((name) => caches.delete(name)));
//       });
//     }
//   });
// }

// serviceWorkerRegistration.unregister();

serviceWorkerRegistration.register();

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
